module.exports = __webpack_public_path__ + "img/collection-memoireRingsRedgold@2x.d9877f6.webp";